// extracted by mini-css-extract-plugin
export var optionGrid = "_8w-7";
export var optionList = "_8w-6";
export var questionsBlock = "_8w-9";
export var spacer = "_8w-5";
export var stepCenteredContent = "_8w-3";
export var stepInner = "_8w-0";
export var stepInnerFullWidth = "_8w-1";
export var stepInnerLockScroll = "_8w-2";
export var stepTransitionFrame = "_8w-4";
export var welcomeBlock = "_8w-8";